import styled from 'styled-components';

export const ImproveTipsWrapper = styled.div`
  display: inline-block;
  width: 100%;
`;

export const Scroller = styled.div`
  max-width: 100%;
  display: flex;
  overflow-x: auto;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  padding: 10px 0;

  border-right: 1px solid ${({ theme }) => theme.palette.divider};
  border-left: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const CardWrapper = styled.div`
  padding: 0 7px;
  display: inline-flex;
`;
